import isObject from "@/util/is-object.mjs";

// Important to ignore infinite objects (or very large objects)
const RegExpIgnore = /(⚡|omni)/i;

function fixString(str: string): string {
  if (!str || str === "null") return ""; // RE sends a lot of string data that is literally "null", even for data types that are not strings :(
  return str;
}

const MAX_DEPTH = 5; // Some arbritrary value to prevent excessive calls, very necessary to prevent crashing
/**
 * This is currently an EFT only utility which will recursively handle strings which should be null, i.e. `"null"` vs `null`.
 *
 * @param obj The object to fix
 * @param depth The current depth of the recursion
 */
export default function deepFixStrings(obj: unknown, depth = 0): void {
  if (!isObject(obj) || depth >= MAX_DEPTH) return;
  for (const key in obj) {
    if (RegExpIgnore.test(key)) continue;
    const value = obj[key];
    if (isObject(value)) {
      deepFixStrings(value, depth + 1);
      continue;
    } else if (typeof value !== "string") {
      continue;
    }
    obj[key] = fixString(value);
  }
}
